import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators";
import { normalizeStyles } from "@webs/components-library/theming";

@customElement("webs-social-link")
export class SocialLink extends LitElement {
  static styles = [
    normalizeStyles,
    css`
      a {
        background-color: rgba(246, 245, 244, 0.1);
        border-radius: 50%;
        display: inline-block;
        height: 1.25rem;
        margin: 0 0.4rem;
        padding: 0.25rem;
        width: 1.25rem;
        transition: background .1s linear;
      }

      a:hover {
        background-color: var(--color-primary);
      }

      img {
        height: 100%;
        object-fit: contain;
        width: 100%;
      }

      @media only screen and (max-width: 768px) {
        a:first-child {
          margin-left: 0;
        }
      }
    `,
  ];

  @property()
  link: string;

  @property()
  image: string;

  @property()
  alt: string;

  protected render(): unknown {
    return html`<a href="${this.link}"><img src="${this.image}" alt="${this.alt}"/></a>`;
  }
}
